import { useEffect, useState } from 'react';
// import { useSearchParams } from 'react-router-dom'
import { zoomServices } from '../../services/zoomServices';
import { playerConfig } from '../../types/playerConfig';
import {
  COOKIE_TOKEN_NAME,
  COOKIE_TOKEN_OPTIONS,
  joiningConfig,
} from '../../utils/constants';
import { Base64 } from '../../utils/encode-utility';
import Player from './player';
import useCookie from '../../utils/useCookie';

export default function VideoPlayerWrapper() {
  const [config, setConfig] = useState<playerConfig>({
    ...joiningConfig,
  });
  const [cookieToken] = useCookie(
    COOKIE_TOKEN_NAME,
    undefined,
    COOKIE_TOKEN_OPTIONS
  );
  // const [searchParams] = useSearchParams()

  useEffect(
    () => {
      let parsedCookieToken = undefined;

      if (cookieToken !== undefined && cookieToken !== 'undefined') {
        const parsedToken = JSON.parse(cookieToken);
        parsedCookieToken = parsedToken?.token;

        console.log('USING COOKIE_TOKEN Auth');
      }
      const queryString = window?.location?.search;
      const isInfo = new URLSearchParams(queryString);
      const info = isInfo.get('info')
        ? isInfo.get('info')
        : Base64.encode(queryString);
      const searchParams = new URLSearchParams(Base64.decode(info));

      const type = searchParams.get('type');
      const token = searchParams.get('token');
      const authToken = parsedCookieToken
        ? parsedCookieToken
        : searchParams.get('auth_token');
      const leaveUrl = searchParams.get('redirection_url');
      const user_name = searchParams.get('username');
      const organization_id = searchParams.get('organization') || '';
      const user_id = searchParams.get('userid') || '';
      const email = searchParams.get('email') || '';
      const coHostDetails = searchParams.get('coHostDetails') || '';
      const source = searchParams.get('source');
      const sessionId = searchParams.get('sessionId');
      const scheduleId = searchParams.get('scheduleId');

      if (!localStorage?.getItem('leaveUrl')) {
        localStorage?.setItem('leaveUrl', leaveUrl as string);
      }

      window.history.replaceState(null, '', `/zoom?info=${info}`);
      (type === 'student'
        ? zoomServices.joinStudent({ token, user_name }, authToken)
        : type === 'publicStudent'
        ? zoomServices.publicStudent({ token, user_name }, authToken)
        : zoomServices.joinHost(
            {
              user_name,
              email,
              coHostDetails,
              source,
              sessionId,
              scheduleId,
            },
            {
              organization_id,
              user_id,
            }
          )
      )
        .then((res: any) => {
          setConfig({
            leaveUrl,
            sdkKey:
              process.env.REACT_APP_SDK_KEY ||
              '21QeFnp6Pz4vRTHsQuN9h0Z0lY3qORiuVCi9',
            ...(res?.data || {}),
          });
        })
        .catch((err) => {
          window.location.href = localStorage?.getItem('leaveUrl')!;
          localStorage?.removeItem('leaveUrl');
        });
    },
    [
      // searchParams
    ]
  );
  return <Player config={config} />;
}
